/* Delegation survives Shopify's cart section replacements. */
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-wv-complement-form]');
  if (!form) return;
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return; // Native POST remains the no-JS/no-drawer fallback.
  event.preventDefault();
  const button = form.querySelector('button');
  if (button.disabled) return;
  const status = form.querySelector('[role="status"]');
  button.disabled = true;
  form.setAttribute('aria-busy', 'true');
  status.textContent = '';
  let added = false;
  try {
    const body = new FormData(form);
    body.append('sections', drawer.getSectionsToRender().map(s => s.id).join(','));
    body.append('sections_url', location.pathname);
    const response = await fetch(window.routes?.cart_add_url || form.action, { method: 'POST', headers: { Accept: 'application/json' }, body });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || status.dataset.error);
    added = true;
    status.textContent = status.dataset.added;
    if (!result.sections || !result.sections['cart-drawer']) {
      location.assign((window.Shopify?.routes?.root || '/') + 'cart');
      return;
    }
    drawer.classList.remove('is-empty');
    drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
    drawer.renderContents(result);
    // Remove the same accessory from PDP suggestions after successful addition.
    document.querySelectorAll('.wv-complements--product [data-complement-handle]').forEach(card => {
      if (card.dataset.complementHandle === form.closest('[data-complement-handle]')?.dataset.complementHandle) card.remove();
    });
  } catch (error) {
    if (added) location.assign((window.Shopify?.routes?.root || '/') + 'cart');
    else status.textContent = error.message || status.dataset.error;
  } finally {
    if (!added) button.disabled = false;
    form.removeAttribute('aria-busy');
  }
});
